import React, { useRef, createContext, useContext } from "react";
import svgPaths from "./svg-gogymv80pu";
import { img01, imgAdobeStock5582371021, img202511281800251, imgImg94681, imgAdobeStock3889188531, imgAdobeStock4267875071, imgAdobeStock4738159761, imgAdobeStock4588800721 } from "./svg-3p84m";
import DiagnosisForm from "./components/DiagnosisForm";

// 新しいFVセクション用インポート
import svgPathsNewFv from "./imports/svg-yx0gc7wegx";
import { img02 } from "./imports/svg-agkmf";
import svgPathsBeforeAfter from "./svg-yy0yjmw4zw";

// FV設定の型定義
interface FvConfigType {
  activeId: string;
  elements?: Array<{
    id: string;
    type: string;
    src?: string;
    content?: string;
  }>;
  variants: Array<{
    id: string;
    label: string;
    images: {
      hero: string;
      heroMask?: string;
      [key: string]: string | undefined;
    };
  }>;
}

// FV設定コンテキスト
const FvConfigContext = createContext<FvConfigType | null>(null);

// 新しいFV用画像パス（デフォルト値）
const DEFAULT_FV_IMG2 = "/images/truemee/fv-new/img2.png";
const fvImg3 = "/images/truemee/fv-new/img3.png";

// 診断フォームへスクロールする関数
const scrollToDiagnosisForm = () => {
  const element = document.getElementById('diagnosis-form');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

// 画像パス定義
const assetBase = "/images/truemee/dashboard-1208";
const heroMain = `${assetBase}/hero.jpg`;
const heroMask = `${assetBase}/hero-mask.png`;
const ctaArrow = "/images/truemee/sp/polygon1.svg";
const dot = `${assetBase}/dot.svg`;
// 既存セクション向け既存アセット（他セクション互換維持用）
const img2 = "/images/truemee/hero-person.svg";
const imgAdobeStock5582371022 = "/images/truemee/testimonial-woman-1.jpg";
const imgAdobeStock12291495201 = "/images/truemee/testimonial-woman-2.jpg";
const img202511281800252 = "/images/truemee/book-cover.png";
const imgImg94682 = "/images/truemee/author-photo.jpg";
const imgAdobeStock3889188532 = "/images/truemee/support-1-workspace.jpg";
const imgAdobeStock4267875072 = "/images/truemee/support-2-meeting.jpg";
const imgAdobeStock4738159762 = "/images/truemee/support-3-business.jpg";
const imgAdobeStock4588800722 = "/images/truemee/author-photo.jpg";
const polygonBottom = `${assetBase}/polygon-bottom.svg`;
const dotAsset = `${assetBase}/dot.svg`;
const bgShape = `${assetBase}/bg-shape.svg`;

function Component1() {
  return (
    <div className="absolute h-[348.22px] left-[999px] top-[23px] w-[362px]" data-name="_饑1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 362 349">
        <g clipPath="url(#clip0_1_495)" id="_é¥1">
          <path d={svgPaths.p11b52680} fill="var(--fill-0, #ED7243)" fillOpacity="0.5" id="Vector" opacity="0.5" />
        </g>
        <defs>
          <clipPath id="clip0_1_495">
            <rect fill="white" height="348.22" width="362" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Component3() {
  return (
    <div className="absolute h-[469px] left-[-213px] top-[351px] w-[476px]" data-name="_饑1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 476 469">
        <g clipPath="url(#clip0_1_463)" id="_é¥1">
          <path d={svgPaths.p21e63400} fill="var(--fill-0, #ED7243)" fillOpacity="0.5" id="Vector" opacity="0.5" />
        </g>
        <defs>
          <clipPath id="clip0_1_463">
            <rect fill="white" height="469" width="476" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Component4() {
  return (
    <div className="absolute h-[469px] left-[1610px] top-[381px] w-[476px]" data-name="_饑1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 476 469">
        <g clipPath="url(#clip0_1_463)" id="_é¥1">
          <path d={svgPaths.p21e63400} fill="var(--fill-0, #ED7243)" fillOpacity="0.5" id="Vector" opacity="0.5" />
        </g>
        <defs>
          <clipPath id="clip0_1_463">
            <rect fill="white" height="469" width="476" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Frame2() {
  return (
    <div className="absolute content-stretch flex font-['Noto_Sans_JP:Medium',sans-serif] font-medium gap-[35px] items-center leading-[normal] left-[746px] text-[#32291f] text-[20px] text-nowrap top-[34px] tracking-[1.4px] whitespace-pre">
      <p className="relative shrink-0">私たちについて</p>
      <p className="relative shrink-0">転職成功事例</p>
      <p className="relative shrink-0">書籍紹介</p>
      <p className="relative shrink-0">サポート</p>
      <p className="relative shrink-0">サービスの流れ</p>
      <p className="relative shrink-0">FAQ</p>
      <p className="relative shrink-0">ログイン</p>
    </div>
  );
}

function Group() {
  return (
    <div className="absolute contents left-[746px] top-[34px]">
      <Frame2 />
    </div>
  );
}

function Cta() {
  return (
    <div className="absolute contents left-[1639px] top-[25px]" data-name="CTA">
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[48.5px] left-[1639px] rounded-[24.267px] to-[#ff512f] top-[25px] w-[241px]" />
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[1655px] text-[13.394px] text-nowrap text-white top-[39px] tracking-[0.6697px] whitespace-pre">無料で職務経歴書の診断を受ける</p>
    </div>
  );
}

function Component() {
  return (
    <div className="absolute contents left-[1639px] top-[25px]" data-name="問い合わせ">
      <Cta />
    </div>
  );
}

function Component5() {
  return (
    <div className="absolute h-[107.085px] left-[169px] top-[-21px] w-[281.266px]" data-name="_ロゴ">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 282 108">
        <g id="_ã­ã´">
          <path d={svgPaths.p424d700} id="Vector" stroke="var(--stroke-0, #40A7CB)" strokeDasharray="3.25 3.25" strokeMiterlimit="10" strokeWidth="0.812977" />
          <path d={svgPaths.p2792c480} fill="var(--fill-0, #473C38)" id="Vector_2" />
          <path d={svgPaths.pe9d3500} fill="var(--fill-0, #473C38)" id="Vector_3" />
          <path d={svgPaths.p5af4600} fill="var(--fill-0, #473C38)" id="Vector_4" />
          <path d={svgPaths.p16709680} fill="var(--fill-0, #473C38)" id="Vector_5" />
          <path d={svgPaths.p1c83e400} fill="var(--fill-0, #ED7243)" id="Vector_6" />
          <path d={svgPaths.p3b9a1180} fill="var(--fill-0, #ED7243)" id="Vector_7" />
          <path d={svgPaths.p263a5c00} fill="var(--fill-0, #473C38)" id="Vector_8" />
          <path d={svgPaths.p1160a100} fill="var(--fill-0, #473C38)" id="Vector_9" />
          <path d={svgPaths.p33c74700} fill="var(--fill-0, #473C38)" id="Vector_10" />
        </g>
      </svg>
    </div>
  );
}

function Header() {
  return (
    <div className="fixed left-0 top-0 w-full z-50" data-name="header" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <div className="bg-white h-[100px] w-full" />
      <div className="absolute left-0 top-0 w-full">
        <Group />
        <Component />
        <Component5 />
      </div>
    </div>
  );
}

// ========================================
// 新しいFVセクションコンポーネント群
// ========================================

// FV (Next.js App with Tailwind (3) 版)
function FvGroup1() {
  // FV設定からヒーロー画像を取得（なければデフォルト）
  const fvConfig = useContext(FvConfigContext);
  const heroImage = fvConfig?.elements?.find(e => e.id === 'hero-image')?.src
    || fvConfig?.variants?.find(v => v.id === fvConfig.activeId)?.images?.hero
    || DEFAULT_FV_IMG2;

  return (
    <div className="absolute contents left-[-0.26px] top-[-260px]">
      <div className="absolute flex h-[900px] items-center justify-center left-[450px] top-[-120px] w-[1650px]">
        <div className="flex-none rotate-[180deg] scale-y-[-100%]">
          <div
            className="h-[900px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[-449.627px_165.878px] mask-size-[2000px_820px] relative w-[1650px]"
            data-name="レイヤー 0 1"
            style={{ maskImage: `url('${img02}')` }}
          >
            <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={heroImage} />
          </div>
        </div>
      </div>
      <div
        className="absolute h-[900px] left-[-0.26px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[0.261px_-0.08px] mask-size-[2000px_820px] top-[0px] w-[2000.5px]"
        style={{ maskImage: `url('${img02}')` }}
      />
    </div>
  );
}

function Component1New() {
  return (
    <div
      className="absolute h-[359px] left-[-112px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[112px_65px] mask-size-[2000px_755px] top-[34px] w-[364px]"
      data-name="_饑1"
      style={{ maskImage: `url('${img02}')` }}
    />
  );
}

function MaskGroup() {
  return (
    <div className="absolute contents left-[-112px] top-[34px]" data-name="Mask group">
      <FvGroup1 />
      <Component1New />
    </div>
  );
}

function Cta2() {
  return (
    <div className="absolute contents left-[300px] top-[643px] cursor-pointer" data-name="CTA" onClick={scrollToDiagnosisForm}>
      <div className="absolute bg-[#f14d2c] h-[97px] left-[300px] rounded-[48.533px] top-[673px] w-[482px] cursor-pointer" onClick={scrollToDiagnosisForm} />
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[97px] left-[300px] rounded-[48.533px] to-[#ff512f] top-[667px] w-[482px] cursor-pointer hover:opacity-90 transition-opacity" onClick={scrollToDiagnosisForm} />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[350px] text-[28px] text-nowrap text-white top-[696px] tracking-[1.4px] whitespace-pre cursor-pointer" onClick={scrollToDiagnosisForm}>
        職務経歴書の診断を受ける
      </p>
      <div className="absolute flex h-[20px] items-center justify-center left-[738px] top-[705.97px] w-[12px]" style={{ "--transform-inner-width": "20", "--transform-inner-height": "12" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[12px] relative w-[20px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 18 9">
                <path d={svgPathsNewFv.p185e4540} fill="var(--fill-0, white)" id="Polygon 1" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bg-[#32291f] h-[48px] left-[350px] rounded-[48.533px] top-[643px] w-[177px] cursor-pointer" onClick={scrollToDiagnosisForm} />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[370px] text-[22px] text-nowrap text-white top-[649px] tracking-[1.1px] whitespace-pre cursor-pointer" onClick={scrollToDiagnosisForm}>
        まずは無料で
      </p>
    </div>
  );
}

function TruemeeFvPC() {
  return (
    <div className="absolute contents left-[200px] top-[-180px]" data-name="fv">
      <MaskGroup />
      <div className="absolute bg-[#FF733E] h-[51px] left-[300px] top-[199px] w-[577px]" />
      <div className="absolute bg-[#FF733E] h-[51px] left-[300px] top-[260px] w-[475px]" />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[310px] text-[36px] text-nowrap text-white top-[197px] tracking-[1.8px] whitespace-pre">
        書類が通らない"本当の理由"を、
      </p>
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[310px] text-[36px] text-white top-[260px] tracking-[1.8px] w-[637px]">
        あなたは知っていますか？
      </p>
      <p className="absolute font-['A_P-OTF_Gothic_MB101_Pr6N:M',sans-serif] font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[300px] not-italic text-[#32291f] text-[0px] text-nowrap top-[341px] tracking-[2.9px] whitespace-pre">
        <span className="text-[#ed7243] text-[65px] tracking-[3.25px]">面接で勝てる職務経歴書</span>
        <span className="text-[50px] tracking-[2.5px]">を</span>
      </p>
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[300px] text-[#32291f] text-[65px] text-nowrap top-[448px] whitespace-pre">
        プロがマンツーマンで
      </p>
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[301px] text-[#32291f] text-[65px] text-nowrap top-[527px] whitespace-pre">
        仕上げます。
      </p>
      <Cta2 />
    </div>
  );
}

// ========================================
// 旧FVセクション（バックアップ用、使用停止）
// ========================================

function MaskGroupOld() {
  return (
    <div className="absolute left-[-120px] top-[40px] h-[820px] w-[2100px]" data-name="Mask group">
      <div className="absolute left-[1176px] top-[193px] h-[579px] w-[939px] rounded-[83px]" style={{ backgroundColor: "#ed7243" }} />
      <div
        className="absolute left-[980px] top-[40px] h-[760px] w-[1100px]"
        style={{
          maskImage: `url('${heroMask}')`,
          WebkitMaskImage: `url('${heroMask}')`,
          maskRepeat: "no-repeat",
          WebkitMaskRepeat: "no-repeat",
          maskSize: "100% 100%",
          WebkitMaskSize: "100% 100%",
        }}
      >
        <img alt="" className="absolute inset-0 size-full max-w-none object-cover pointer-events-none" src={heroMain} />
      </div>
      <div className="absolute left-[-60px] top-[20px] h-[360px] w-[360px]" data-name="_bg-shape">
        <img alt="" className="block size-full max-w-none" src={bgShape} />
      </div>
    </div>
  );
}

function Cta2Old() {
  return (
    <div className="absolute left-[300px] top-[667px] cursor-pointer" data-name="CTA" onClick={scrollToDiagnosisForm}>
      <div className="absolute bg-[#f14d2c] h-[97px] left-[0px] rounded-[48.533px] top-[6px] w-[482px]" />
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[97px] left-[0px] rounded-[48.533px] to-[#ff512f] top-[0px] w-[482px] hover:opacity-90 transition-opacity" />
      <div className="absolute bg-[#32291f] h-[48px] left-[50px] rounded-[48.533px] top-[-24px] w-[177px] flex items-center justify-center">
        <p className="font-['Noto_Sans_JP:Bold',sans-serif] text-[22px] text-white tracking-[1.1px]">まずは無料で</p>
      </div>
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[50px] text-[28px] text-white top-[29px] tracking-[1.4px]">
        職務経歴書の診断を受ける
      </p>
      <div className="absolute flex h-[20px] items-center justify-center left-[422px] top-[35px] w-[20px]">
        <img alt="" className="block size-full" src={ctaArrow} />
      </div>
    </div>
  );
}

function FvOld() {
  return (
    <div className="absolute left-[0px] top-[0px] w-[2000px] h-[1150px]" data-name="fv">
      <div className="absolute bg-[#fffaf8] h-[720px] left-[-159px] top-[0px] w-[2320px]" />
      <div className="absolute bg-[#f9dacf] h-[222px] left-1/2 top-[854px] translate-x-[-50%] w-[2000px]" />
      <div className="absolute flex h-[116px] items-center justify-center left-1/2 top-[1076px] translate-x-[-50%] w-[2000px]">
        <div className="flex-none scale-y-[-100%]">
          <div className="h-[116px] relative w-[2000px]">
            <img alt="" className="block max-w-none size-full" src={polygonBottom} />
          </div>
        </div>
      </div>
      <MaskGroupOld />
      <div className="absolute left-[300px] top-[197px]">
        <div className="absolute bg-[#FF733E] h-[51px] left-[0px] top-[2px] w-[577px]" />
        <div className="absolute bg-[#FF733E] h-[51px] left-[0px] top-[63px] w-[475px]" />
        <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[10px] text-[36px] text-white top-[0px] tracking-[1.8px]">
          書類が通らない"本当の理由"を、
        </p>
        <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[10px] text-[36px] text-white top-[63px] tracking-[1.8px] whitespace-pre-wrap">
          あなたは知っていますか？
        </p>
        <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[0px] text-[#32291f] text-[65px] top-[144px] tracking-[3.25px]">
          <span className="text-[#ed7243]">面接で勝てる職務経歴書</span>
          <span className="text-[50px] tracking-[2.5px]">を</span>
        </p>
        <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[0px] text-[#32291f] text-[65px] top-[251px]">
          プロがマンツーマンで
        </p>
        <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[1px] text-[#32291f] text-[65px] top-[330px]">
          仕上げます。
        </p>
        <Cta2Old />
        <div className="absolute flex gap-[13px] left-[222px] top-[251px]">
          {[0, 1, 2, 3, 4, 5].map((_, idx) => (
            <img key={idx} alt="" className="size-3" src={dot} />
          ))}
        </div>
      </div>
    </div>
  );
}

// 新しいFVを使用するためのラッパー
function Fv() {
  return <TruemeeFvPC />;
}

function About() {
  return (
    <div className="absolute left-0 top-[780px] w-[2000px] flex justify-center" data-name="about">
      <div
        className="relative w-full max-w-[2000px] px-[300px] pt-[60px] pb-[80px]"
        style={{
          background: "linear-gradient(180deg, rgba(237,114,67,0.12) 0%, rgba(237,114,67,0.12) 100%)",
          clipPath: "polygon(0 0, 100% 0, 100% 70%, 50% 100%, 0 70%)",
        }}
      >
        <p className="font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[1.25] text-[#32291f] text-[60px] text-center tracking-[3px]">
          なぜTruemeeなら「選考を突破できる」
          <br aria-hidden="true" />
          職務経歴書になるのか？
        </p>
      </div>
    </div>
  );
}

// BeforeAfter（Next.js App with Tailwind (3) 版）
function Before() {
  return (
    <div className="absolute contents left-[404px] top-[1866px]" data-name="before">
      <div className="absolute bg-white border border-[#d9d9d9] border-solid h-[310px] left-[405px] top-[1866px] w-[557px]" />
      <div className="absolute bg-[#646464] h-[72px] left-[404px] top-[1866px] w-[558px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[469px] text-[#32291f] text-[20px] top-[1964px] tracking-[2px] w-[442px]">
        新規顧客開拓を担当し、売上アップに貢献しました。
        <br aria-hidden="true" />
        課題を発見し、改善施策の立案を行いました。
        <br aria-hidden="true" />
        チームで協力しながら業務効率化を進めました。
      </p>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[624px] not-italic text-[32px] text-nowrap text-white top-[1879px] tracking-[1.6px] whitespace-pre">Before</p>
    </div>
  );
}

function After() {
  return (
    <div className="absolute contents left-[1038px] top-[1866px]" data-name="after">
      <div className="absolute bg-white border border-[#ed7243] border-solid h-[310px] left-[1039px] top-[1866px] w-[557px]" />
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[72px] left-[1038px] to-[#ff512f] top-[1866px] w-[558px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal h-[86.111px] leading-[30px] left-[1099px] text-[#32291f] text-[20px] top-[2000.91px] tracking-[2px] w-[452px]">
        前職では、担当エリアの休眠顧客72社の訪問戦略を立案し、3ヶ月で稼働率を18%→52%に改善。売上は前年比132%を達成。
      </p>
      <p className="absolute font-['Hiragino_UD_Sans_StdN:W6',sans-serif] h-[45.926px] leading-[normal] left-[1275px] not-italic text-[32px] text-white top-[1879px] tracking-[1.6px] w-[85px]">After</p>
    </div>
  );
}

function BeforeAfter() {
  return (
    <div className="absolute contents left-[291px] top-[1229px]" data-name="before after1">
      <div className="absolute bg-[#fdf5f2] h-[664px] left-[291px] top-[1580px] w-[1440px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[48px] left-[603px] text-[#32291f] text-[24px] text-nowrap top-[1729px] tracking-[2.4px] whitespace-pre">
        課題は「訪問頻度は高いが、意思決定者に到達していない」点にあり、
        <br aria-hidden="true" />
        上層部向けの新提案資料を自作し、商談率を4倍に引き上げました。
      </p>
      <div className="absolute bg-[#ed7243] h-[138px] left-[291px] top-[1532px] w-[1440px]" />
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[48px] left-[1009px] text-[#32291f] text-[32px] text-center top-[1229px] tracking-[3.2px] translate-x-[-50%] w-[1102px] z-10">
        <p className="mb-0">私たちは、AI添削や一般的なテンプレートでは絶対に発見できない、</p>
        <p className="mb-0">
          <span className="font-['Noto_Sans_JP:Bold',sans-serif] font-bold">「あなたの本質的な価値」</span>を引き出します。
        </p>
        <p className="mb-0">職務経歴書の書き方を熟知したプロが、</p>
        <p>あなたの過去の経験を独自のロジックで徹底的に深掘りします。</p>
      </div>
      <Before />
      <After />
      <div className="absolute flex h-[58px] items-center justify-center left-[992px] top-[1987px] w-[35px]" style={{ "--transform-inner-width": "58", "--transform-inner-height": "35" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[35px] relative w-[58px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 51 27">
                <path d={svgPathsBeforeAfter.p3c0a1a00} fill="url(#paint0_linear_1_518)" id="Polygon 3" />
                <defs>
                  <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_518" x1="-3.88526" x2="54.1147" y1="17.5" y2="17.5">
                    <stop stopColor="#FF512F" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[58px] items-center justify-center left-[966px] top-[1987px] w-[35px]" style={{ "--transform-inner-width": "58", "--transform-inner-height": "35" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[35px] relative w-[58px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 51 27">
                <path d={svgPathsBeforeAfter.p3c0a1a00} fill="url(#paint0_linear_1_500)" id="Polygon 4" />
                <defs>
                  <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_500" x1="-3.88526" x2="54.1147" y1="17.5" y2="17.5">
                    <stop stopColor="#F09819" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[54px] left-[1000.5px] text-[36px] text-center text-nowrap text-white top-[1547px] tracking-[1.8px] translate-x-[-50%] whitespace-pre z-10">
        <p className="mb-0">Truemeeでは"なぜ・どうやって・どれだけ成果を出したか"</p>
        <p>が一目でわかるように添削しています</p>
      </div>
    </div>
  );
}

function Before1() {
  return (
    <div className="absolute contents left-[407px] top-[2619px]" data-name="before">
      <div className="absolute bg-white border border-[#d9d9d9] border-solid h-[354px] left-[408px] top-[2619px] w-[557px]" />
      <div className="absolute bg-[#646464] h-[72px] left-[407px] top-[2619px] w-[558px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[472px] text-[#32291f] text-[20px] top-[2729px] tracking-[2px] w-[449px]">
        営業として顧客対応、受注管理、提案資料の作成などを経験。
        <br aria-hidden="true" />
        製品知識を活かして新規顧客への提案を行う。
        <br aria-hidden="true" />
        見積作成、請求処理、問い合わせ対応を担当。
      </p>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[634px] not-italic text-[32px] text-nowrap text-white top-[2636px] tracking-[1.6px] whitespace-pre">Before</p>
    </div>
  );
}

function After1() {
  return (
    <div className="absolute contents left-[1040px] top-[2619px]" data-name="after">
      <div className="absolute bg-white border border-[#ed7243] border-solid h-[354px] left-[1041px] top-[2619px] w-[557px]" />
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[72px] left-[1040px] to-[#ff512f] top-[2619px] w-[558px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[27px] left-[1100px] text-[#32291f] text-[18px] top-[2729px] tracking-[1.8px] w-[447px]">
        【役割】プロジェクト営業（顧客課題の特定〜提案〜導入支援を一気通貫）
        <br aria-hidden="true" />
        【成果】新規商談数 月12件 → 21件（175%増）
        <br aria-hidden="true" />
        【強み】顧客の「決裁プロセス（4段階）」を可視化し、提案タイミングを最適化
        <br aria-hidden="true" />
        【行動】営業プロセスの型化により、メンバー3名の数字も改善
      </p>
      <p className="absolute font-['Hiragino_UD_Sans_StdN:W6',sans-serif] h-[45.926px] leading-[normal] left-[1277px] not-italic text-[32px] text-white top-[2632px] tracking-[1.6px] w-[85px]">After</p>
    </div>
  );
}

function BeforeAfter1() {
  return (
    <div className="absolute contents left-[280px] top-[2406px]" data-name="before after2">
      <div className="absolute bg-[#fdf5f2] h-[546px] left-[280px] top-[2497px] w-[1440px]" />
      <div className="absolute bg-[#ed7243] h-[136px] left-[280px] top-[2406px] w-[1440px]" />
      <p className="absolute left-1/2 top-[2436px] translate-x-[-50%] font-['Noto_Sans_JP:Bold',sans-serif] text-[36px] text-white leading-[54px] tracking-[1.8px] text-center whitespace-pre z-10">
        Truemeeではフレームワークをメインに
        <br />
        思考の流れを可視化します
      </p>
      <Before1 />
      <After1 />
      <div className="absolute flex h-[58px] items-center justify-center left-[998px] top-[2790px] w-[35px]" style={{ "--transform-inner-width": "58", "--transform-inner-height": "35" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[35px] relative w-[58px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 51 27">
                <path d={svgPathsBeforeAfter.p3c0a1a00} fill="url(#paint0_linear_1_518)" id="Polygon 3" />
                <defs>
                  <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_518" x1="-3.88526" x2="54.1147" y1="17.5" y2="17.5">
                    <stop stopColor="#FF512F" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[58px] items-center justify-center left-[972px] top-[2790px] w-[35px]" style={{ "--transform-inner-width": "58", "--transform-inner-height": "35" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[35px] relative w-[58px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 51 27">
                <path d={svgPathsBeforeAfter.p3c0a1a00} fill="url(#paint0_linear_1_500)" id="Polygon 4" />
                <defs>
                  <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_500" x1="-3.88526" x2="54.1147" y1="17.5" y2="17.5">
                    <stop stopColor="#F09819" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Before5() {
  return (
    <div className="absolute contents left-[407px] top-[3416px]" data-name="before">
      <div className="absolute bg-white border border-[#d9d9d9] border-solid h-[355px] left-[408px] top-[3416px] w-[557px]" />
      <div className="absolute bg-[#646464] h-[71px] left-[407px] top-[3416px] w-[558px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[472px] text-[#32291f] text-[20px] top-[3522px] tracking-[2px] w-[460px]">
        経理業務として月次決算や会計ソフトへのデータ入力を担当。
        <br aria-hidden="true" />
        年次決算サポート、請求書や経費精算のチェック業務を経験。
        <br aria-hidden="true" />
        上司の指示に基づき定型業務を遂行。
      </p>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[634px] not-italic text-[32px] text-nowrap text-white top-[3429px] tracking-[1.6px] whitespace-pre">Before</p>
    </div>
  );
}

function After3() {
  return (
    <div className="absolute contents left-[1036px] top-[3416px]" data-name="after">
      <div className="absolute bg-white border border-[#ed7243] border-solid h-[355px] left-[1037px] top-[3416px] w-[557px]" />
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[71px] left-[1036px] to-[#ff512f] top-[3416px] w-[558px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[27px] left-[1095px] text-[#32291f] text-[18px] top-[3524px] tracking-[1.8px] w-[439px]">
        【実績】月次決算の締め作業を平均8日→4日に短縮（前年比50%削減）
        <br aria-hidden="true" />
        【工夫】Excelマクロを独学で習得し、仕訳データの自動化フローを構築
        <br aria-hidden="true" />
        【成果】決算早期化により、経営陣への報告タイミングを5営業日前倒し
        <br aria-hidden="true" />
        【評価】業務フロー改善が評価され、次年度の決算チームリーダーに抜擢
      </p>
      <p className="absolute font-['Helvetica:Regular',sans-serif] h-[45.926px] leading-[normal] left-[1273px] not-italic text-[32px] text-white top-[3435px] tracking-[1.6px] w-[85px]">After</p>
    </div>
  );
}

function BeforeAfter2() {
  return (
    <div className="absolute contents left-[280px] top-[3206px]" data-name="before after3">
      <div className="absolute bg-[#fdf5f2] h-[636px] left-[280px] top-[3206px] w-[1440px]" />
      <div className="absolute bg-[#ed7243] h-[141px] left-[280px] top-[3206px] w-[1440px]" />
      <p className="absolute left-1/2 top-[3230px] translate-x-[-50%] font-['Noto_Sans_JP:Bold',sans-serif] text-[36px] text-white leading-[54px] tracking-[1.8px] text-center whitespace-pre z-10">
        Truemeeでは数字の根拠など、
        <br />
        より具体的な指摘をし矛盾点を洗い出します
      </p>
      <Before5 />
      <After3 />
      <div className="absolute flex h-[58px] items-center justify-center left-[989px] top-[3588px] w-[35px]" style={{ "--transform-inner-width": "58", "--transform-inner-height": "35" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[35px] relative w-[58px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 51 27">
                <path d={svgPathsBeforeAfter.p3c0a1a00} fill="url(#paint0_linear_1_518)" id="Polygon 3" />
                <defs>
                  <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_518" x1="-3.88526" x2="54.1147" y1="17.5" y2="17.5">
                    <stop stopColor="#FF512F" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[58px] items-center justify-center left-[963px] top-[3588px] w-[35px]" style={{ "--transform-inner-width": "58", "--transform-inner-height": "35" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[35px] relative w-[58px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 51 27">
                <path d={svgPathsBeforeAfter.p3c0a1a00} fill="url(#paint0_linear_1_500)" id="Polygon 4" />
                <defs>
                  <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_500" x1="-3.88526" x2="54.1147" y1="17.5" y2="17.5">
                    <stop stopColor="#F09819" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Cta4() {
  return (
    <div className="relative w-[676px] h-[136px]" data-name="CTA">
      <div className="absolute inset-0 bg-gradient-to-r from-[#f09819] to-[#ff512f] rounded-[68.07px] cursor-pointer hover:opacity-90 transition-opacity" onClick={scrollToDiagnosisForm} />
      <p className="absolute left-[62px] top-[42px] font-['Noto_Sans_JP:Medium',sans-serif] text-[33.661px] text-white tracking-[1.683px]" onClick={scrollToDiagnosisForm}>
        無料で職務経歴書の診断を受ける
      </p>
      <div className="absolute right-[42px] top-[54px] h-[28px] w-[28px]">
        <img alt="" className="block size-full" src={ctaArrow} />
      </div>
    </div>
  );
}

function Cta1() {
  return (
    <div className="absolute left-1/2 top-[3900px] w-[1400px] -translate-x-1/2 flex flex-col items-center text-center" data-name="CTA1">
      <p className="font-['Noto_Sans_JP:Bold',sans-serif] text-[48px] text-[#32291f] tracking-[2.4px] mb-4">
        これらの内容を今なら実質0円で無料
      </p>
      <p className="font-['Noto_Sans_JP:Medium',sans-serif] text-[24px] text-[#32291f] tracking-[1.2px] mb-10">
        あなたの職務経歴書もこう変わります
      </p>
      <Cta4 />
    </div>
  );
}

function MaskGroup1() {
  return (
    <div className="absolute contents left-[509px] top-[4830.01px]" data-name="Mask group">
      <div className="absolute h-[255px] left-[463px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[46px_59px] mask-size-[114px_114px] top-[4771.01px] w-[383px]" data-name="AdobeStock_558237102 1" style={{ maskImage: `url('${imgAdobeStock5582371021}')` }}>
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={imgAdobeStock5582371022} />
      </div>
    </div>
  );
}

function Component6() {
  return (
    <div className="absolute contents left-[484px] top-[4810.99px]" data-name="利用者の声1">
      <div className="absolute bg-white h-[934px] left-[484px] rounded-[29px] top-[4810.99px] w-[490px]">
        <div aria-hidden="true" className="absolute border border-[rgba(50,41,31,0.5)] border-solid inset-[-1px] pointer-events-none rounded-[30px]" />
      </div>
      <div className="absolute font-['Hiragino_UD_Sans_StdN:W6',sans-serif] leading-[0] left-[509px] not-italic text-[#32291f] text-[18px] top-[5004.99px] tracking-[1.8px] w-[446px]">
        <p className="font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[36px] mb-0 tracking-[1.6px]">自分では条件が厳しすぎて無理だと思っていました。</p>
        <p className="leading-[36px] mb-0 tracking-[1.6px]">
          <span className="font-['Noto_Sans_JP:Regular',sans-serif] font-normal">でも、これまでの経験を一つずつ深掘りしてもらい、</span>
          <span className="font-['Noto_Sans_JP:Medium',sans-serif] font-medium text-[#ed7243]">「こう伝えれば評価されるのか」と初めて腑に落ちました。</span>
        </p>
        <p className="font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[36px] mb-0 tracking-[1.6px]">添削後は面接でも自信をもって話せるようになりました。</p>
        <p className="font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[28px] mt-4 tracking-[1.4px] text-[14px] text-[#888]">※プライバシー保護のため、表記を一部変更しています。</p>
      </div>
      <div className="absolute bg-[#ed7243] h-[21px] left-[509px] top-[4968.01px] w-[76px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[normal] left-[516px] text-[14px] text-nowrap text-white top-[4969.99px] tracking-[0.7px] whitespace-pre">30代前半</p>
      <div className="absolute bg-[#ed7243] h-[21px] left-[601px] top-[4968.01px] w-[93px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[normal] left-[603px] text-[14px] text-nowrap text-white top-[4969.99px] tracking-[0.7px] whitespace-pre">正社員未経験</p>
      <MaskGroup1 />
      <div className="absolute font-['Hiragino_UD_Sans_StdN:W6',sans-serif] leading-[0] left-[641px] not-italic text-[20px] text-black text-nowrap top-[4842.01px] tracking-[1px] whitespace-pre">
        <p className="font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[35px] mb-0 text-[#32291f]">正社員経験なし・子育て中でも</p>
        <p className="font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[35px] mb-0">
          <span className="text-[#ed7243]">"経験の見せ方"</span>
          <span className="text-[#32291f]">を変えて</span>
        </p>
        <p className="font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[35px]">
          <span className="text-[#ed7243]">正社員に内定</span>
        </p>
      </div>
    </div>
  );
}

function MaskGroup2() {
  return (
    <div className="absolute contents left-[1038px] top-[4830.01px]" data-name="Mask group">
      <div className="absolute h-[393px] left-[756px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[282px_110px] mask-size-[114px_114px] top-[4720.01px] w-[590px]" data-name="AdobeStock_1229149520 1" style={{ maskImage: `url('${imgAdobeStock5582371021}')` }}>
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={imgAdobeStock12291495201} />
      </div>
    </div>
  );
}

function Component2() {
  return (
    <div className="absolute contents left-[1013px] top-[4810.99px]" data-name="利用者の声2">
      <div className="absolute bg-white h-[480px] left-[1013px] rounded-[29px] top-[4810.99px] w-[490px]">
        <div aria-hidden="true" className="absolute border border-[rgba(50,41,31,0.5)] border-solid inset-[-1px] pointer-events-none rounded-[30px]" />
      </div>
      <p className="absolute font-['Hiragino_UD_Sans_StdN:W6',sans-serif] font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[36px] left-[1038px] not-italic text-[#32291f] text-[18px] top-[5018.01px] tracking-[1.6px] tracking-[1.8px] w-[446px]">
        転職の軸が定まらず、書類が通らなかった時期がありました。面接でも志望理由をうまく説明できませんでした。<span className="text-[#ed7243]">キャリアの軸を一緒に整理していただき、方向性が明確になりました。</span>その結果、新しい業種への転職に成功することができました。
        <span className="block mt-4 text-[14px] text-[#888]">※プライバシー保護のため、表記を一部変更しています。</span>
      </p>
      <div className="absolute bg-[#ed7243] h-[21px] left-[1038px] top-[4968.01px] w-[76px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[normal] left-[1044px] text-[14px] text-nowrap text-white top-[4969.99px] tracking-[0.7px] whitespace-pre">30代後半</p>
      <div className="absolute bg-[#ed7243] h-[21px] left-[1130px] top-[4968.01px] w-[109px]" />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[normal] left-[1133px] text-[14px] text-nowrap text-white top-[4969.99px] tracking-[0.7px] whitespace-pre">新業種への挑戦</p>
      <MaskGroup2 />
      <div className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[35px] left-[1177px] text-[#32291f] text-[20px] text-nowrap top-[4827.01px] tracking-[1px] whitespace-pre">
        <p className="mb-0">方向性が決まらず迷っていた</p>
        <p className="mb-0">30代女性が</p>
        <p className="mb-0"><span className="text-[#ed7243]">新しい業種</span>での</p>
        <p><span className="text-[#ed7243]">転職に成功</span></p>
      </div>
    </div>
  );
}

function Component7() {
  return (
    <div className="h-[207.51px] relative w-[177.87px]" data-name="_編集モード">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 178 208">
        <g clipPath="url(#clip0_1_437)" id="_ç·¨éã¢ã¼ã">
          <path d={svgPaths.p39c28400} fill="url(#paint0_linear_1_437)" id="Vector" />
          <path d={svgPaths.pba86c00} id="Vector_2" stroke="var(--stroke-0, #FF733E)" strokeMiterlimit="10" strokeOpacity="0.57" strokeWidth="1.32324" />
        </g>
        <defs>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_437" x1="1.33164" x2="168.36" y1="122.661" y2="122.659">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <clipPath id="clip0_1_437">
            <rect fill="white" height="207.51" width="177.87" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Component8() {
  return (
    <div className="h-[59.62px] relative w-[92.818px]" data-name="_編集モード">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 93 60">
        <g clipPath="url(#clip0_1_454)" id="_ç·¨éã¢ã¼ã">
          <path d={svgPaths.p1e526500} fill="url(#paint0_linear_1_454)" id="Vector" />
          <path d={svgPaths.pe062500} fill="url(#paint1_linear_1_454)" id="Vector_2" />
          <path d={svgPaths.p19542c40} fill="url(#paint2_linear_1_454)" id="Vector_3" />
        </g>
        <defs>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_454" x1="4.38329e-05" x2="8.65348" y1="10.4829" y2="10.4829">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_1_454" x1="18.1297" x2="64.2032" y1="41.3884" y2="30.514">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint2_linear_1_454" x1="71.8521" x2="92.8176" y1="10.4988" y2="10.4988">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <clipPath id="clip0_1_454">
            <rect fill="white" height="59.6196" width="92.8177" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Component9() {
  return (
    <div className="h-[59.62px] relative w-[92.818px]" data-name="_編集モード">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 93 60">
        <g id="_ç·¨éã¢ã¼ã">
          <path d={svgPaths.p1e526500} fill="url(#paint0_linear_1_451)" id="Vector" />
        </g>
        <defs>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_451" x1="4.38329e-05" x2="8.65348" y1="10.4829" y2="10.4829">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

function Component10() {
  return (
    <div className="absolute contents left-[-383px] top-[4341px]" data-name="利用者の声">
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[559px] text-[#32291f] text-[60px] text-nowrap top-[4452.01px] tracking-[3px] whitespace-pre">選考を突破した先に広がる未来</p>
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[48px] left-[999px] text-[#32291f] text-[32px] text-center text-nowrap top-[4574.99px] tracking-[3.2px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">Truemeeの添削ロジックは、職務経歴書の悩みを本質的に解決し、</p>
        <p className="mb-0">選考突破という具体的な成果に繋がっています。</p>
        <p>私たちがサポートした方々の「生の声」と「実績」をご覧ください。</p>
      </div>
      <Component6 />
      <Component2 />
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[48px] left-[997.5px] text-[#32291f] text-[32px] text-center top-[5817.99px] tracking-[3.2px] translate-x-[-50%] w-[1097px]">
        <p className="mb-0">私たちは、これまでに100名以上のキャリアチェンジを</p>
        <p className="mb-0">サポートしてきました。AIやテンプレートでは対応できない、</p>
        <p className="mb-0">
          一人ひとりの<span className="font-['Noto_Sans_JP:Bold',sans-serif] font-bold text-[#ed7243]">「核となるストーリー」</span>を引き出し、
        </p>
        <p>
          職務経歴書に反映させています。
          <br aria-hidden="true" />
          この確かな実績こそが、あなたの選考突破を力強く後押しします。
        </p>
      </div>
      <div className="absolute flex h-[220.093px] items-center justify-center left-[1202px] top-[5353.99px] w-[242.284px]" style={{ "--transform-inner-width": "177.859375", "--transform-inner-height": "207.5" } as React.CSSProperties}>
        <div className="flex-none rotate-[283.036deg]">
          <Component7 />
        </div>
      </div>
      <div className="absolute flex inset-[32.14%_80.97%_62.81%_-19.15%] items-center justify-center">
        <div className="flex-none h-[610.769px] rotate-[195.392deg] skew-x-[359.147deg] w-[614.776px]">
          <div className="relative size-full" data-name="Vector">
            <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 615 611">
              <path d={svgPaths.p3be49100} fill="url(#paint0_linear_1_474)" fillOpacity="0.7" id="Vector" />
              <defs>
                <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_474" x1="307.388" x2="307.388" y1="-3.2936" y2="610.807">
                  <stop stopColor="#F09819" />
                  <stop offset="1" stopColor="#FF512F" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[99.443px] items-center justify-center left-[460px] top-[4341px] w-[110.296px]" style={{ "--transform-inner-width": "92.8125", "--transform-inner-height": "59.609375" } as React.CSSProperties}>
        <div className="flex-none rotate-[148.366deg]">
          <Component8 />
        </div>
      </div>
      <div className="absolute flex h-[99.443px] items-center justify-center left-[1467px] top-[4488.99px] w-[110.296px]" style={{ "--transform-inner-width": "92.8125", "--transform-inner-height": "59.609375" } as React.CSSProperties}>
        <div className="flex-none rotate-[148.366deg]">
          <Component9 />
        </div>
      </div>
    </div>
  );
}

function Cta6() {
  return (
    <div className="absolute contents left-[664px] top-[7562px]" data-name="CTA">
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[136.046px] left-[664px] rounded-[68.07px] to-[#ff512f] top-[7601.76px] w-[676.024px] cursor-pointer hover:opacity-90 transition-opacity" onClick={scrollToDiagnosisForm} />
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[725.71px] text-[33.661px] text-nowrap text-white top-[7646.6px] tracking-[1.683px] whitespace-pre cursor-pointer" onClick={scrollToDiagnosisForm}>無料で職務経歴書の診断を受ける</p>
      <div className="absolute flex h-[28.051px] items-center justify-center left-[1278.31px] top-[7656.42px] w-[16.83px]" style={{ "--transform-inner-width": "28.046875", "--transform-inner-height": "16.828125" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[16.83px] relative w-[28.051px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 13">
                <path d={svgPaths.ped8cd70} fill="var(--fill-0, white)" id="Polygon 1" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[791px] text-[#32291f] text-[24px] text-nowrap top-[7562px] tracking-[1.2px] whitespace-pre">プロにあなたの強みを見つけてもらう</p>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[773px] top-[7565px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[70.71deg]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 8" stroke="var(--stroke-0, #32291F)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[1226px] top-[7565px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[109.29deg] scale-y-[-100%]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 9" stroke="var(--stroke-0, #32291F)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Cta3() {
  return (
    <div className="absolute contents left-[664px] top-[7562px]" data-name="CTA3">
      <Cta6 />
    </div>
  );
}

function MaskGroup3() {
  return (
    <div className="absolute contents left-[583px] top-[6897px]" data-name="Mask group">
      <div className="absolute h-[228px] left-[583px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[0px] mask-size-[158px_220px] top-[6897px] w-[158px]" data-name="スクリーンショット 2025-11-28 18.00.25 1" style={{ maskImage: `url('${img202511281800251}')` }}>
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={img202511281800252} />
      </div>
    </div>
  );
}

function MaskGroup4() {
  return (
    <div className="absolute contents left-[583px] top-[7130px]" data-name="Mask group">
      <div className="absolute h-[256px] left-[583px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[0px_35px] mask-size-[158px_162px] top-[7095px] w-[170px]" data-name="IMG_9468 1" style={{ maskImage: `url('${imgImg94681}')` }}>
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={imgImg94682} />
      </div>
    </div>
  );
}

function Profile() {
  return (
    <div className="absolute contents left-[4px] top-[6528px]" data-name="profile">
      <div className="absolute bg-gradient-to-t from-[rgba(240,152,25,0.3)] h-[228px] left-[4px] to-[rgba(255,81,47,0.3)] top-[6528px] w-[2004px]" />
      <Cta3 />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[1021.5px] text-[#32291f] text-[60px] text-center text-nowrap top-[6573px] tracking-[3px] translate-x-[-50%] whitespace-pre">メディアも認めた「職務経歴書のプロ」</p>
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[677px] text-[#32291f] text-[32px] text-nowrap top-[6668px] tracking-[0.64px] whitespace-pre">その知識と経験が、あなたの未来を切り拓く</p>
      <MaskGroup3 />
      <MaskGroup4 />
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[1008px] text-[#32291f] text-[20px] text-center text-nowrap top-[6786px] tracking-[2px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">書籍で公開されている、「採用担当者の心理」を突く独自のロジックを、</p>
        <p>あなたの職務経歴書に直接適用します。</p>
      </div>
      <div className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[42px] left-[773px] text-[#32291f] text-[28px] text-nowrap top-[6897px] tracking-[1.4px] whitespace-pre">
        <p className="mb-0">{`『職務経歴書で"あなたの実績"を最大限に魅せる！　`}</p>
        <p>{`　～凡人でも即実践！　あなたの価値を最大化する秘訣』`}</p>
      </div>
      <p className="absolute font-['Noto_Sans_JP:SemiBold',sans-serif] leading-[normal] left-[799px] not-italic text-[#32291f] text-[24px] text-nowrap top-[7017px] tracking-[0.48px] whitespace-pre">著者： 仲丸 武宏</p>
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[normal] left-[791px] text-[#32291f] text-[20px] text-nowrap top-[7140px] tracking-[2px] whitespace-pre">Xrosspoint代表取締役社長</p>
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[791px] text-[#32291f] text-[20px] text-nowrap top-[7200px] tracking-[2px] whitespace-pre">
        <p className="mb-0">普段はDXや業務改善などの伴走型経営コンサルタントとして活躍。</p>
        <p className="mb-0">そのコンサルタントとしての高度な言語化スキルと</p>
        <p>レジュメ作成ノウハウを活かし、求職者のキャリアアップを支援。</p>
      </div>
      <div className="absolute h-0 left-[784px] top-[7117px] w-[714px]">
        <div className="absolute bottom-0 left-0 right-0 top-[-1px]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 714 1">
            <line id="Line 7" stroke="var(--stroke-0, #32291F)" x2="714" y1="0.5" y2="0.5" />
          </svg>
        </div>
      </div>
      <div className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[48px] left-[1019px] text-[#32291f] text-[32px] text-center text-nowrap top-[7389px] tracking-[3.2px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">個人の実績を深掘りするための思考プロセスを言語化することにより、</p>
        <p>実績の再現性をアピールし、選考通過率向上を実現します。</p>
      </div>
    </div>
  );
}

function Cta7({ onClick }: { onClick?: () => void }) {
  return (
    <div className="absolute contents left-[662px] top-[9647px]" data-name="CTA">
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[136.046px] left-[662px] rounded-[68.07px] to-[#ff512f] top-[9686.76px] w-[676.024px] cursor-pointer hover:opacity-90 transition-opacity" onClick={onClick} />
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[735px] text-[33.661px] text-nowrap text-white top-[9735px] tracking-[1.683px] whitespace-pre cursor-pointer" onClick={onClick}>無料で職務経歴書の診断を受ける</p>
      <div className="absolute flex h-[28.051px] items-center justify-center left-[1276.31px] top-[9741.42px] w-[16.83px]" style={{ "--transform-inner-width": "28.046875", "--transform-inner-height": "16.828125" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[16.83px] relative w-[28.051px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 13">
                <path d={svgPaths.ped8cd70} fill="var(--fill-0, white)" id="Polygon 1" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[892px] text-[#32291f] text-[24px] text-nowrap top-[9647px] tracking-[1.2px] whitespace-pre">最短3分で申し込み</p>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[867px] top-[9650px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[70.71deg]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 8" stroke="var(--stroke-0, #32291F)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[1124px] top-[9650px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[109.29deg] scale-y-[-100%]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 9" stroke="var(--stroke-0, #32291F)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Cta8({ onClick }: { onClick?: () => void }) {
  return (
    <div className="absolute contents left-[662px] top-[9647px]" data-name="CTA3">
      <Cta7 onClick={onClick} />
    </div>
  );
}

function Contents() {
  return (
    <div className="absolute h-[110.47px] left-[600px] top-[8289px] w-[98.744px]" data-name="contents">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 99 111">
        <g clipPath="url(#clip0_1_421)" id="contents">
          <path d={svgPaths.p2fe23b80} fill="var(--fill-0, #32291F)" id="Vector" />
          <path d={svgPaths.p8deb200} fill="var(--fill-0, #32291F)" id="Vector_2" />
          <path d={svgPaths.p20da6680} fill="var(--fill-0, #32291F)" id="Vector_3" />
          <path d={svgPaths.p13f9c8f0} fill="var(--fill-0, #32291F)" id="Vector_4" />
          <path d={svgPaths.p24d9a1f0} fill="var(--fill-0, #32291F)" id="Vector_5" />
          <path d={svgPaths.p20e7d180} fill="var(--fill-0, #32291F)" id="Vector_6" />
        </g>
        <defs>
          <clipPath id="clip0_1_421">
            <rect fill="white" height="110.47" width="98.744" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Step() {
  return (
    <div className="absolute contents left-[449px] top-[8198px]" data-name="step1">
      <div className="absolute bg-white h-[283px] left-[449px] top-[8198px] w-[1098px]" />
      <p className="absolute font-['Helvetica:Bold',sans-serif] leading-[normal] left-[822px] not-italic text-[#ed7243] text-[40px] text-nowrap top-[8238px] tracking-[2px] whitespace-pre">STEP 01</p>
      <p className="absolute font-['Hiragino_Kaku_Gothic_ProN:W3',sans-serif] leading-[48px] left-[822px] not-italic text-[#32291f] text-[32px] text-nowrap top-[8314px] tracking-[3.2px] whitespace-pre">
        フォームに必要事項を入力するだけで、
        <br aria-hidden="true" />
        あなたの強み整理がスタートします。
      </p>
      <Contents />
    </div>
  );
}

function Contents1() {
  return (
    <div className="absolute h-[91.675px] left-[576px] top-[8642px] w-[127.682px]" data-name="contents">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 128 92">
        <g clipPath="url(#clip0_1_484)" id="contents">
          <path d={svgPaths.pf9e5000} fill="var(--fill-0, #32291F)" id="Vector" />
          <path d={svgPaths.p3d957200} fill="var(--fill-0, #32291F)" id="Vector_2" />
          <path d={svgPaths.p35456300} fill="var(--fill-0, #32291F)" id="Vector_3" />
          <path d={svgPaths.p21925600} fill="var(--fill-0, #32291F)" id="Vector_4" />
          <path d={svgPaths.p1af01c0} fill="var(--fill-0, #32291F)" id="Vector_5" />
          <path d={svgPaths.p20640e00} fill="var(--fill-0, #32291F)" id="Vector_6" />
          <path d={svgPaths.p3748ee00} fill="var(--fill-0, #32291F)" id="Vector_7" />
        </g>
        <defs>
          <clipPath id="clip0_1_484">
            <rect fill="white" height="91.6746" width="127.682" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Step1() {
  return (
    <div className="absolute contents left-[450px] top-[8544px]" data-name="step2">
      <div className="absolute bg-white h-[283px] left-[450px] top-[8544px] w-[1095px]" />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[823.98px] text-[#ed7243] text-[40px] top-[8574px] tracking-[2px] whitespace-nowrap">STEP 02</p>
      <Contents1 />
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[48px] left-[823.98px] text-[#32291f] text-[32px] top-[8650px] tracking-[3.2px] w-[683.128px]">
        <p className="mb-0">
          担当者がヒアリングを行い、
          <br aria-hidden="true" />
          経験・実績を深掘りして“伝わる材料”を
        </p>
        <p>収集します。</p>
      </div>
    </div>
  );
}

function Contents2() {
  return (
    <div className="absolute h-[135.161px] left-[592px] top-[8981px] w-[90.716px]" data-name="contents">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 91 136">
        <g clipPath="url(#clip0_1_429)" id="contents">
          <path d={svgPaths.p31e4b800} fill="var(--fill-0, #32291F)" id="Vector" />
          <g id="Group">
            <path d={svgPaths.p1307c100} fill="var(--fill-0, #32291F)" id="Vector_2" />
            <path d={svgPaths.p2137740} fill="var(--fill-0, #32291F)" id="Vector_3" />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1_429">
            <rect fill="white" height="135.161" width="90.7163" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Step2() {
  return (
    <div className="absolute contents left-[450px] top-[8890px]" data-name="step3">
      <div className="absolute bg-white h-[283px] left-[450px] top-[8890px] w-[1094px]" />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[822px] text-[#ed7243] text-[40px] text-nowrap top-[8921px] tracking-[2px] whitespace-pre">STEP 03</p>
      <Contents2 />
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[48px] left-[822px] text-[#32291f] text-[32px] text-nowrap top-[8998px] tracking-[3.2px] whitespace-pre">
        添削・作成スタート。
        <br aria-hidden="true" />
        プロがあなたの実績を言語化し、
        <br aria-hidden="true" />
        面接で話しやすい構造に整えます。
      </p>
    </div>
  );
}

function Step3() {
  return (
    <div className="absolute contents left-[450px] top-[9236px]" data-name="step4">
      <div className="absolute bg-white h-[283px] left-[450px] top-[9236px] w-[1094px]" />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[822px] text-[#ed7243] text-[40px] text-nowrap top-[9294px] tracking-[2px] whitespace-pre">STEP 04</p>
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[48px] left-[822px] text-[#32291f] text-[32px] text-nowrap top-[9366px] tracking-[3.2px] whitespace-pre">
        完成した職務経歴書を納品。
        <br aria-hidden="true" />
        必要に応じて面接対策もサポートします。
      </p>
      <div
        className="absolute"
        style={{ left: "620px", top: "9315px", width: "122px", height: "91px" }}
        data-name="Vector"
      >
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 122 91">
          <path d={svgPaths.p3c9ed280} fill="var(--fill-0, #32291F)" id="Vector" />
        </svg>
      </div>
    </div>
  );
}

function Flow({ onClick }: { onClick?: () => void }) {
  return (
    <div className="absolute contents left-[-26px] top-[7905px]" data-name="flow">
      <div className="absolute bg-gradient-to-b from-[rgba(255,81,47,0.3)] h-[2067px] left-[-26px] to-[rgba(240,152,25,0.3)] top-[7905px] w-[2026px]" />
      <Cta8 onClick={onClick} />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[819px] text-[#32291f] text-[60px] text-nowrap top-[8013px] tracking-[3px] whitespace-pre">ご利用の流れ</p>
      <Step />
      <Step1 />
      <Step2 />
      <Step3 />
    </div>
  );
}

function Component11() {
  return (
    <div className="absolute h-[557px] left-[1564px] top-[10219px] w-[602.186px]" data-name="_饑1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 603 557">
        <g clipPath="url(#clip0_1_416)" id="_é¥1">
          <path d={svgPaths.p38d28b00} fill="var(--fill-0, #ED7243)" fillOpacity="0.5" id="Vector" opacity="0.5" />
        </g>
        <defs>
          <clipPath id="clip0_1_416">
            <rect fill="white" height="557" width="602.186" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function MaskGroup5() {
  return (
    <div className="absolute contents left-[345px] top-[10486px]" data-name="Mask group">
      <div className="absolute h-[273.717px] left-[334.95px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[10.049px_14.392px] mask-size-[406px_240px] top-[10471.6px] w-[425.16px]" data-name="AdobeStock_388918853 1" style={{ maskImage: `url('${imgAdobeStock3889188531}')` }}>
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={imgAdobeStock3889188532} />
      </div>
    </div>
  );
}

function MaskGroup6() {
  return (
    <div className="absolute contents left-[826px] top-[10486px]" data-name="Mask group">
      <div className="absolute h-[241.058px] left-[786.14px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[39.862px_0px] mask-size-[378px_239.858px] top-[10486px] w-[524.083px]" data-name="AdobeStock_426787507 1" style={{ maskImage: `url('${imgAdobeStock4267875071}')` }}>
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={imgAdobeStock4267875072} />
      </div>
    </div>
  );
}

function MaskGroup7() {
  return (
    <div className="absolute contents left-[1277px] top-[10485px]" data-name="Mask group">
      <div className="absolute h-[254.711px] left-[1277px] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[0px_0.69px] mask-size-[379.799px_241px] top-[10484.3px] w-[382.02px]" data-name="AdobeStock_473815976 1" style={{ maskImage: `url('${imgAdobeStock4738159761}')` }}>
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={imgAdobeStock4738159762} />
      </div>
    </div>
  );
}

function Component12() {
  return (
    <div className="h-[207.51px] relative w-[177.87px]" data-name="_編集モード">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 178 208">
        <g clipPath="url(#clip0_1_406)" id="_ç·¨éã¢ã¼ã">
          <path d={svgPaths.p39c28400} fill="url(#paint0_linear_1_406)" id="Vector" />
          <path d={svgPaths.p31304400} id="Vector_2" stroke="var(--stroke-0, #FF733E)" strokeMiterlimit="10" strokeOpacity="0.57" strokeWidth="1.32324" />
        </g>
        <defs>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_406" x1="1.33164" x2="168.36" y1="122.661" y2="122.659">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <clipPath id="clip0_1_406">
            <rect fill="white" height="207.51" width="177.87" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Component13() {
  return (
    <div className="absolute contents left-[97px] top-[10133px]" data-name="強み">
      <div className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[120px] left-[1014px] text-[#32291f] text-[60px] text-center text-nowrap top-[10133px] tracking-[3px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">あなたのキャリアを引き出す</p>
        <p>3つのサポート</p>
      </div>
      <Component11 />
      <MaskGroup5 />
      <MaskGroup6 />
      <MaskGroup7 />
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[48px] left-[537px] text-[#ed7243] text-[28px] text-center text-nowrap top-[10809px] tracking-[1.4px] translate-x-[-50%] whitespace-pre">（あなたの強みの可視化）</p>
      <p className="absolute font-['Hiragino_UD_Sans_StdN:W6',sans-serif] font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[48px] left-[536.5px] not-italic text-[#ed7243] text-[0px] text-[28px] text-center text-nowrap top-[10761px] tracking-[1.4px] translate-x-[-50%] whitespace-pre">情報整理</p>
      <div className="absolute font-['Hiragino_UD_Sans_StdN:W6',sans-serif] font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[48px] left-[1014px] not-italic text-[#ed7243] text-[0px] text-[28px] text-center text-nowrap top-[10756px] tracking-[1.4px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">面接対策</p>
        <p>（想定質問×フィードバック）</p>
      </div>
      <div className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[48px] left-[1482.5px] text-[#ed7243] text-[28px] text-center text-nowrap top-[10750px] tracking-[1.4px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">企業マッピング</p>
        <p>（あなたに合う求人の方向性）</p>
      </div>
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[537px] text-[#32291f] text-[20px] text-center text-nowrap top-[10871px] tracking-[2px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">経験・実績を整理し、強みが</p>
        <p>ひと目でわかる構成に整えます。</p>
      </div>
      <p className="absolute bg-clip-text bg-gradient-to-r font-['Helvetica:Bold',sans-serif] from-[#f09819] leading-[normal] left-[365.5px] not-italic text-[80px] text-center text-nowrap to-[#ff512f] top-[10436px] tracking-[1.6px] translate-x-[-50%] whitespace-pre" style={{ WebkitTextFillColor: "transparent" }}>
        01
      </p>
      <p className="absolute bg-clip-text bg-gradient-to-r font-['Helvetica:Bold',sans-serif] from-[#f09819] leading-[normal] left-[1300.5px] not-italic text-[80px] text-center text-nowrap to-[#ff512f] top-[10440px] tracking-[1.6px] translate-x-[-50%] whitespace-pre" style={{ WebkitTextFillColor: "transparent" }}>
        03
      </p>
      <p className="absolute bg-clip-text bg-gradient-to-r font-['Helvetica:Bold',sans-serif] from-[#f09819] leading-[normal] left-[850.5px] not-italic text-[80px] text-center text-nowrap to-[#ff512f] top-[10440px] tracking-[1.6px] translate-x-[-50%] whitespace-pre" style={{ WebkitTextFillColor: "transparent" }}>
        02
      </p>
      <p className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[818px] text-[#32291f] text-[20px] text-nowrap top-[10866px] tracking-[2px] whitespace-pre">
        「聞かれたら困る質問」まで想定し、
        <br aria-hidden="true" />
        自信を持って話せる状態をつくります。
      </p>
      <div className="absolute font-['Noto_Sans_JP:Regular',sans-serif] font-normal leading-[30px] left-[1483px] text-[#32291f] text-[20px] text-center text-nowrap top-[10862px] tracking-[2px] translate-x-[-50%] whitespace-pre">
        <p className="mb-0">
          希望条件・実績を基に、
          <br aria-hidden="true" />
          転職の方向性が明確になるレポートを
        </p>
        <p>提示します。</p>
      </div>
      <div className="absolute flex h-[262.965px] items-center justify-center left-[97px] top-[10845px] w-[248.483px]" style={{ "--transform-inner-width": "177.859375", "--transform-inner-height": "207.5" } as React.CSSProperties}>
        <div className="flex-none rotate-[24.788deg]">
          <Component12 />
        </div>
      </div>
    </div>
  );
}

function Q() {
  return (
    <div className="absolute contents left-[450px] top-[11252px]" data-name="Q1">
      <div className="absolute bg-gradient-to-b from-[rgba(255,81,47,0.3)] h-[202px] left-[450px] to-[rgba(240,152,25,0.3)] top-[11252px] w-[1097px]" />
      <div className="absolute left-[471px] size-[58px] top-[11283px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 58 58">
          <circle cx="29" cy="29" fill="var(--fill-0, #ED7243)" id="Ellipse 23" r="29" />
        </svg>
      </div>
      <div className="absolute left-[471px] size-[58px] top-[11364px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 58 58">
          <circle cx="29" cy="29" fill="var(--fill-0, #FCFCFC)" id="Ellipse 24" r="28.5" stroke="var(--stroke-0, #ED7243)" />
        </svg>
      </div>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[500px] not-italic text-[20px] text-center text-nowrap text-white top-[11300px] tracking-[1px] translate-x-[-50%] whitespace-pre">Q</p>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[500px] not-italic text-[#ed7243] text-[20px] text-center text-nowrap top-[11381px] tracking-[1px] translate-x-[-50%] whitespace-pre">A</p>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[703px] text-[#32291f] text-[20px] text-center text-nowrap top-[11297px] tracking-[2px] translate-x-[-50%] whitespace-pre">初回の相談料はかかりますか？</p>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[811.5px] text-[#32291f] text-[20px] text-center text-nowrap top-[11379px] tracking-[2px] translate-x-[-50%] whitespace-pre">無料です。まずは職務経歴書の現状診断を行います。</p>
    </div>
  );
}

function Q1() {
  return (
    <div className="absolute contents left-[448px] top-[11493px]" data-name="Q2">
      <div className="absolute bg-gradient-to-b from-[rgba(255,81,47,0.3)] h-[202px] left-[448px] to-[rgba(240,152,25,0.3)] top-[11493px] w-[1097px]" />
      <div className="absolute left-[471px] size-[58px] top-[11524px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 58 58">
          <circle cx="29" cy="29" fill="var(--fill-0, #ED7243)" id="Ellipse 23" r="29" />
        </svg>
      </div>
      <div className="absolute left-[471px] size-[58px] top-[11605px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 58 58">
          <circle cx="29" cy="29" fill="var(--fill-0, #FCFCFC)" id="Ellipse 24" r="28.5" stroke="var(--stroke-0, #ED7243)" />
        </svg>
      </div>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[500px] not-italic text-[20px] text-center text-nowrap text-white top-[11541px] tracking-[1px] translate-x-[-50%] whitespace-pre">Q</p>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[500px] not-italic text-[#ed7243] text-[20px] text-center text-nowrap top-[11621px] tracking-[1px] translate-x-[-50%] whitespace-pre">A</p>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[757.5px] text-[#32291f] text-[20px] text-center text-nowrap top-[11538px] tracking-[2px] translate-x-[-50%] whitespace-pre">AIで作った職務経歴書でも大丈夫ですか？</p>
      <div className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[30px] left-[549px] text-[#32291f] text-[20px] text-nowrap top-[11603px] tracking-[2px] whitespace-pre">
        <p className="mb-0">問題ありません。</p>
        <p>AIで作られた文章は強みが埋もれがちなので、 プロの観点からしっかり再構築します。</p>
      </div>
    </div>
  );
}

function Q2() {
  return (
    <div className="absolute contents left-[448px] top-[11734px]" data-name="Q3">
      <div className="absolute bg-gradient-to-b from-[rgba(255,81,47,0.3)] h-[202px] left-[448px] to-[rgba(240,152,25,0.3)] top-[11734px] w-[1097px]" />
      <div className="absolute left-[471px] size-[58px] top-[11765px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 58 58">
          <circle cx="29" cy="29" fill="var(--fill-0, #ED7243)" id="Ellipse 23" r="29" />
        </svg>
      </div>
      <div className="absolute left-[471px] size-[58px] top-[11846px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 58 58">
          <circle cx="29" cy="29" fill="var(--fill-0, #FCFCFC)" id="Ellipse 24" r="28.5" stroke="var(--stroke-0, #ED7243)" />
        </svg>
      </div>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[500px] not-italic text-[20px] text-center text-nowrap text-white top-[11782px] tracking-[1px] translate-x-[-50%] whitespace-pre">Q</p>
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[500px] not-italic text-[#ed7243] text-[20px] text-center text-nowrap top-[11863px] tracking-[1px] translate-x-[-50%] whitespace-pre">A</p>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[747px] text-[#32291f] text-[20px] text-center text-nowrap top-[11782px] tracking-[2px] translate-x-[-50%] whitespace-pre">未経験業界への転職も相談できますか？</p>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[888.5px] text-[#32291f] text-[20px] text-center text-nowrap top-[11863px] tracking-[2px] translate-x-[-50%] whitespace-pre">可能です。これまでの経験から強みを抽出し、方向性を整理します。</p>
    </div>
  );
}

function Qa() {
  return (
    <div className="absolute contents left-[448px] top-[11108px]" data-name="QA">
      <p className="absolute font-['Noto_Sans_JP:Bold',sans-serif] font-bold leading-[normal] left-[992.5px] text-[#32291f] text-[60px] text-center text-nowrap top-[11108px] tracking-[3px] translate-x-[-50%] whitespace-pre">よくある質問</p>
      <Q />
      <Q1 />
      <Q2 />
    </div>
  );
}

function MaskGroup8() {
  return (
    <div className="absolute inset-0" data-name="Mask group">
      <div className="absolute inset-0 bg-[url('/images/truemee/support-1-workspace.jpg')] bg-cover bg-center" />
      <div className="absolute inset-0 bg-[rgba(107,74,47,0.35)]" />
    </div>
  );
}

function Cta9({ onClick }: { onClick?: () => void }) {
  return (
    <div className="relative flex items-center justify-center w-[676.024px] h-[220px]" data-name="CTA">
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-1/2 -translate-x-1/2 text-[24px] text-nowrap text-white top-[24px] tracking-[1.2px] whitespace-pre">
        3分で完了・まずは診断から
      </p>
      <div
        className="absolute bg-gradient-to-r from-[#f09819] h-[136.046px] left-1/2 -translate-x-1/2 rounded-[68.07px] to-[#ff512f] top-[70px] w-[676.024px] cursor-pointer hover:opacity-90 transition-opacity"
        onClick={onClick}
      />
      <p
        className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-1/2 -translate-x-1/2 text-[33.661px] text-nowrap text-white top-[120px] tracking-[1.683px] whitespace-pre cursor-pointer"
        onClick={onClick}
      >
        無料で職務経歴書の診断を受ける
      </p>
      <div className="absolute flex h-[28.051px] items-center justify-center left-[614.31px] top-[125.4px] w-[16.83px]" style={{ "--transform-inner-width": "28.046875", "--transform-inner-height": "16.828125" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[16.83px] relative w-[28.051px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 13">
                <path d={svgPaths.ped8cd70} fill="var(--fill-0, white)" id="Polygon 1" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[161px] top-[30px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[70.71deg]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 8" stroke="var(--stroke-0, white)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[501px] top-[30px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[109.29deg] scale-y-[-100%]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 9" stroke="var(--stroke-0, white)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Cta10({ onClick }: { onClick?: () => void }) {
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center" data-name="CTA3">
      <Cta9 onClick={onClick} />
    </div>
  );
}

function Cta5({ onClick }: { onClick?: () => void }) {
  return (
    <div className="absolute left-[-33px] top-[12104px] w-[2052px] h-[520px] overflow-hidden relative" data-name="CTA5">
      <div className="absolute inset-0 bg-[#fff7f2] z-0" />
      <div className="absolute inset-0 z-10">
        <MaskGroup8 />
      </div>
      <Cta10 onClick={onClick} />
    </div>
  );
}

function Component14() {
  return (
    <div className="absolute h-[107.085px] left-[841px] top-[14423px] w-[281.266px]" data-name="_ロゴ">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 282 108">
        <g id="_ã­ã´">
          <path d={svgPaths.p31ba7300} fill="var(--fill-0, #473C38)" id="Vector" />
          <path d={svgPaths.p14289cf0} fill="var(--fill-0, #473C38)" id="Vector_2" />
          <path d={svgPaths.p5af4600} fill="var(--fill-0, #473C38)" id="Vector_3" />
          <path d={svgPaths.p1fc18800} fill="var(--fill-0, #473C38)" id="Vector_4" />
          <path d={svgPaths.p1a210480} fill="var(--fill-0, #ED7243)" id="Vector_5" />
          <path d={svgPaths.pda85780} fill="var(--fill-0, #ED7243)" id="Vector_6" />
          <path d={svgPaths.p22b6a00} fill="var(--fill-0, #473C38)" id="Vector_7" />
          <path d={svgPaths.p28489a80} fill="var(--fill-0, #473C38)" id="Vector_8" />
          <path d={svgPaths.p1c05f00} fill="var(--fill-0, #473C38)" id="Vector_9" />
        </g>
      </svg>
    </div>
  );
}

function Frame() {
  return (
    <div className="absolute content-stretch flex font-['Noto_Sans_JP:Regular',sans-serif] font-normal gap-[35px] items-center leading-[normal] left-[757px] text-[#32291f] text-[20px] text-nowrap top-[14577px] tracking-[1px] whitespace-pre">
      <p className="relative shrink-0">利用規約</p>
      <p className="relative shrink-0">お問い合わせ</p>
      <p className="relative shrink-0">利用手順</p>
      <p className="relative shrink-0">FAQ</p>
    </div>
  );
}

function Frame1() {
  return (
    <div className="absolute content-stretch flex font-['Noto_Sans_JP:Regular',sans-serif] font-normal gap-[35px] items-center leading-[normal] left-[825px] text-[#32291f] text-[16px] text-nowrap top-[14633px] tracking-[0.8px] whitespace-pre">
      <p className="relative shrink-0">個人情報利用許諾</p>
      <p className="relative shrink-0">特定商取引法</p>
    </div>
  );
}

function Footer() {
  return (
    <div className="absolute contents left-[-21px] top-[14423px]" data-name="footer">
      <div className="absolute bg-[#32291f] h-[132px] left-[-21px] top-[14728px] w-[2035px]" />
      <p className="absolute font-['Helvetica:Regular',sans-serif] leading-[normal] left-[812px] not-italic text-[16px] text-nowrap text-white top-[14785px] tracking-[0.8px] whitespace-pre">© 2025 Xrosspoint Inc. All rights reserved.</p>
      <Component14 />
      <Frame />
      <Frame1 />
    </div>
  );
}

function Component15() {
  return (
    <div className="h-[59.62px] relative w-[92.818px]" data-name="_編集モード">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 93 60">
        <g clipPath="url(#clip0_1_378)" id="_ç·¨éã¢ã¼ã">
          <path d={svgPaths.p1e526500} fill="url(#paint0_linear_1_378)" id="Vector" />
          <path d={svgPaths.pe062500} fill="url(#paint1_linear_1_378)" id="Vector_2" />
          <path d={svgPaths.p19542c40} fill="url(#paint2_linear_1_378)" id="Vector_3" />
        </g>
        <defs>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_378" x1="4.38329e-05" x2="8.65348" y1="10.4829" y2="10.4829">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_1_378" x1="18.1297" x2="64.2032" y1="41.3884" y2="30.514">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint2_linear_1_378" x1="71.8521" x2="92.8176" y1="10.4988" y2="10.4988">
            <stop stopColor="#FF512F" stopOpacity="0.7" />
            <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
          </linearGradient>
          <clipPath id="clip0_1_378">
            <rect fill="white" height="59.6196" width="92.8177" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Cta11({ onClick }: { onClick?: () => void }) {
  return (
    <div className="absolute contents left-[661px] top-[6189.99px]" data-name="CTA">
      <div className="absolute bg-gradient-to-r from-[#f09819] h-[136.046px] left-[661px] rounded-[68.07px] to-[#ff512f] top-[6224.76px] w-[676.024px] cursor-pointer hover:opacity-90 transition-opacity" onClick={onClick} />
      <p className="absolute font-['Noto_Sans_JP:SemiBold',sans-serif] leading-[normal] left-[712px] not-italic text-[33.661px] text-nowrap text-white top-[6270.99px] tracking-[1.683px] whitespace-pre cursor-pointer" onClick={onClick}>無料で職務経歴書の診断を受ける</p>
      <div className="absolute flex h-[28.051px] items-center justify-center left-[1275.31px] top-[6279.41px] w-[16.83px]" style={{ "--transform-inner-width": "28.046875", "--transform-inner-height": "16.828125" } as React.CSSProperties}>
        <div className="flex-none rotate-[90deg]">
          <div className="h-[16.83px] relative w-[28.051px]">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 13">
                <path d={svgPaths.ped8cd70} fill="var(--fill-0, white)" id="Polygon 1" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <p className="absolute font-['Noto_Sans_JP:Medium',sans-serif] font-medium leading-[normal] left-[810px] text-[#32291f] text-[24px] text-nowrap top-[6189.99px] tracking-[1.2px] whitespace-pre">通過した人の共通点を無料で体験</p>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[792px] top-[6191.99px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[70.71deg]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 8" stroke="var(--stroke-0, #32291F)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-[23.294px] items-center justify-center left-[1197px] top-[6191.99px] w-[8.153px]" style={{ "--transform-inner-width": "24.671875", "--transform-inner-height": "0" } as React.CSSProperties}>
        <div className="flex-none rotate-[109.29deg] scale-y-[-100%]">
          <div className="h-0 relative w-[24.679px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1.16px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25 2">
                <line id="Line 9" stroke="var(--stroke-0, #32291F)" strokeWidth="1.16468" x2="24.6791" y1="0.58234" y2="0.58234" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Props型定義
interface TruemeePcAProps {
  fvConfig?: FvConfigType | null;
}

export default function TruemeePcA({ fvConfig }: TruemeePcAProps) {
  return (
    <FvConfigContext.Provider value={fvConfig || null}>
      <div
        className="bg-white relative size-full"
        data-name="truemee_pc_A"
        style={{ marginTop: "-80px" }}
      >
        <div className="absolute bg-[#fcfcfc] h-[14951px] left-[-72px] top-[-166px] w-[2072px]" />
        <div className="absolute bg-[#fffaf8] h-[755px] left-[-159px] top-[99px] w-[2320px]" />
        {/* TruemeeHeader removed - using layout.tsx MarketingHeader */}
        <Fv />
      {/* FVと下セクションの間に余白と白背景を挿入し、重なりを防ぐ */}
      <div className="relative w-full h-[20px] bg-white" />
      <About />
      <BeforeAfter />
      <BeforeAfter1 />
      <BeforeAfter2 />
      <Cta1 />
      <Component10 />
      <div className="absolute flex inset-[30.57%_22.81%_69.24%_75.75%] items-center justify-center">
        <div className="flex-none h-[20.542px] rotate-[149.088deg] skew-x-[1.452deg] w-[20.806px]">
          <div className="relative size-full" data-name="Vector">
            <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 21 21">
              <path d={svgPaths.pfaa3000} fill="url(#paint0_linear_1_449)" id="Vector" />
              <defs>
                <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_449" x1="0" x2="20.8057" y1="10.2708" y2="10.2708">
                  <stop stopColor="#FF512F" stopOpacity="0.7" />
                  <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div className="absolute flex inset-[30.25%_19.45%_69.31%_77.2%] items-center justify-center">
        <div className="flex-none h-[46.679px] rotate-[135.9deg] skew-x-[1.626deg] w-[46.683px]">
          <div className="relative size-full" data-name="Vector">
            <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 47 47">
              <path d={svgPaths.pd866100} fill="url(#paint0_linear_1_445)" id="Vector" />
              <defs>
                <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_445" x1="0" x2="46.6834" y1="23.3397" y2="23.3397">
                  <stop stopColor="#FF512F" stopOpacity="0.7" />
                  <stop offset="1" stopColor="#F09819" stopOpacity="0.7" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <Profile />
      <Flow onClick={scrollToDiagnosisForm} />
      <Component13 />
      <Qa />
      <Cta5 onClick={scrollToDiagnosisForm} />
      {/* TruemeeFooter removed - using layout.tsx Footer */}
      <div className="absolute flex h-[106.184px] items-center justify-center left-[1421px] top-[6201px] w-[109.005px]" style={{ "--transform-inner-width": "92.8125", "--transform-inner-height": "59.609375" } as React.CSSProperties}>
        <div className="flex-none rotate-[221.555deg]">
          <Component15 />
        </div>
      </div>
      <Cta11 onClick={scrollToDiagnosisForm} />
      <div className="absolute flex h-0 items-center justify-center left-[463px] top-[6687px] w-[201px]">
        <div className="flex-none rotate-[180deg]">
          <div className="h-0 relative w-[201px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 201 1">
                <line id="Line 10" stroke="var(--stroke-0, black)" x2="201" y1="0.5" y2="0.5" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute flex h-0 items-center justify-center left-[1350px] top-[6687px] w-[201px]">
        <div className="flex-none rotate-[180deg]">
          <div className="h-0 relative w-[201px]">
            <div className="absolute bottom-0 left-0 right-0 top-[-1px]">
              <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 201 1">
                <line id="Line 10" stroke="var(--stroke-0, black)" x2="201" y1="0.5" y2="0.5" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      {/* 診断フォーム */}
      <div id="diagnosis-form" className="absolute left-[448px] top-[12755px] w-[1097px]">
        <DiagnosisForm />
      </div>
      </div>
    </FvConfigContext.Provider>
  );
}